import { createSelector } from "reselect";
import _ from 'lodash'

export const correspondantsIsLoadingSelector = state => state.correspondants.correspondants.loading;
export const correspondantsIsErrorSelector = state => state.correspondants.correspondants.error;

export const allCorrespondantsSelector = state => (state.entities.correspondants || {});
export const correspondantsResultSelector = state => state.correspondants.correspondants.result;


export const visibleCorrespondantsSelector = createSelector(
  allCorrespondantsSelector,
  (correspondants = {}) => _.filter(correspondants, (task) => !!task._id)
)

export const correspondantSelector = createSelector(
  visibleCorrespondantsSelector,
  (_, props) => props,
  (correspondants = [], correspondantId) => {
    return correspondants.filter((correspondant) => correspondant.id === correspondantId)
  }
);

export const makeCorrespondantSelector = () => correspondantSelector;

export const correspondantsSelector = createSelector(
  visibleCorrespondantsSelector,
  (correspondants = []) => {
    return correspondants
  }
);

export const makeCorrespondantsSelector = () => correspondantsSelector;




